import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../components/api";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";
import AuthContext from "../context/AuthContext";
import axios from "axios";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Card } from "react-bootstrap";
import ExcelSVG from "../../ExcelSVG.svg";
import FilterSVG from "../../FilterSVG.svg";
import Button from "react-bootstrap/Button";
import * as XLSX from "xlsx";
import Modal from "react-bootstrap/Modal";

function DealerInfrastructureFee() {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(2);
  const [dealers, setDealers] = useState([]);
  const [commissionTotal, setCommissionTotal] = useState([]);
  const [rechargeTotal, setRechargeTotal] = useState([]);
  const [percentageTotal, setPercentageTotal] = useState([]);
  const [startDate, setStartDate] = useState(""); // Beginning date
  const [endDate, setEndDate] = useState(""); // End date
  const [filters, setFilters] = useState({
    dealer_transaction_id: "",
    dealer_transaction_details: "",
    amount: "",
    action: "",
    credit_account: "",
    debit_account: "",
    creation_date: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });

  const [searchInput, setSearchInput] = useState(""); // To capture search input

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchDealers = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/administration/dealers/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: { username: user.username },
        });

        if (response.status === 200) {
          let options = response.data.map((item) => ({
            label: item.fullname_en,
            value: item.dealer_id,
          }));
          options.push({ label: "All", value: "All" });
          setDealers(options);
        }
      } catch (error) {
        console.error("Error fetching dealers:", error);
      }
    };

    fetchDealers();
  }, [user.username]);

  useEffect(() => {
    const fetchCommission = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const url =
          selectedOption === "All"
            ? `${API_URL}/administration/infrastructure/fee/commission/all/`
            : `${API_URL}/administration/infrastructure/fee/commission/`;

        const { data } = await axios.get(url, {
          headers: { Authorization: `Bearer ${authTokens.access}` },
          params:
            selectedOption !== "All"
              ? {
                  dealer: selectedOption,
                  start_date: startDate,
                  end_date: endDate,
                }
              : { start_date: startDate, end_date: endDate },
        });

        setCommissionTotal(data.Commission_Fee || 0);
        console.log("Commission:", data.Commission_Fee);
      } catch (error) {
        console.error("Error fetching commission total:", error);
      }
    };

    const fetchRecharge = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const url =
          selectedOption === "All"
            ? `${API_URL}/administration/infrastructure/fee/recharge/all/`
            : `${API_URL}/administration/infrastructure/fee/recharge/`;

        const { data } = await axios.get(url, {
          headers: { Authorization: `Bearer ${authTokens.access}` },
          params:
            selectedOption !== "All"
              ? {
                  dealer: selectedOption,
                  start_date: startDate,
                  end_date: endDate,
                }
              : { start_date: startDate, end_date: endDate },
        });

        setRechargeTotal(data.Recharge_Fee || 0);
        console.log("Recharge:", data.Recharge_Fee);
      } catch (error) {
        console.error("Error fetching recharge total:", error);
      }
    };

    const fetchPercentage = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const url =
          selectedOption === "All"
            ? `${API_URL}/administration/infrastructure/fee/percentage/all/`
            : `${API_URL}/administration/infrastructure/fee/percentage/`;

        const { data } = await axios.get(url, {
          headers: { Authorization: `Bearer ${authTokens.access}` },
          params:
            selectedOption !== "All"
              ? {
                  dealer: selectedOption,
                  start_date: startDate,
                  end_date: endDate,
                }
              : { start_date: startDate, end_date: endDate },
        });

        setPercentageTotal(data.Percentage_Fee || 0);
        console.log("Percentage:", data.Percentage_Fee);
      } catch (error) {
        console.error("Error fetching percentage total:", error);
      }
    };

    const fetchData = async () => {
      setLoading(true);
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const url =
          selectedOption === "All"
            ? `${API_URL}/administration/infrastructure/fee/all/`
            : `${API_URL}/administration/infrastructure/fee/`;

        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${authTokens.access}` },
          params:
            selectedOption !== "All"
              ? {
                  dealer: selectedOption,
                  start_date: startDate,
                  end_date: endDate,
                }
              : { start_date: startDate, end_date: endDate },
        });

        setData(response.data);
        filteredRows(response.data);
      } catch (error) {
        console.error("Error fetching infrastructure fee data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCommission();
    fetchRecharge();
    fetchPercentage();
    fetchData();
  }, [selectedOption, startDate, endDate]);

  // Create a delayed search filter function
  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  // Effect to handle session storage for search query
  useEffect(() => {
    const searchValue = sessionStorage.getItem("searchInfrastructure"); // Get saved search value from session storage
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchInfrastructure") {
        sessionStorage.removeItem(key); // Clear other session data but keep search query
      }
    });

    if (searchValue) {
      sessionStorage.setItem("searchInfrastructure", searchValue);
      setSearchQuery(searchValue); // Set the search query if available
    }
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchInfrastructure", query);

    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 100);
    setSearchFilterTimeout(newTimeout);
  };

  const handleSelectChange = (selected) => {
    setSelectedOption(selected?.value || null);
  };

  const columns = [
    { field: "dealer_transaction_id", headerName: "Number", minWidth: 20 },
    {
      field: "dealer_transaction_details",
      headerName: "Details",
      flex: 1,
      minWidth: 300,
    },
    { field: "amount", headerName: "Amount", flex: 1, minWidth: 150 },
    { field: "action", headerName: "Action", minWidth: 50 },
    { field: "credit_account", headerName: "Credit", minWidth: 50 },
    { field: "debit_account", headerName: "Debit", minWidth: 50 },
    {
      field: "creation_date",
      headerName: "Creation Date",
      minWidth: 230,
      sortable: true,
      sort: "desc",
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleString();
      },
    },
  ];

  // IMPROVED: Combined filtering logic that works for both display AND export
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      if (key === "connectivity_dependent") {
        const filterValue = filters[key].toLowerCase();
        if (row.connectivity === "Fiber") {
          return (row.code || "").toLowerCase().includes(filterValue);
        } else if (row.connectivity === "Wireless") {
          return (row.name || "").toLowerCase().includes(filterValue);
        }
        return false;
      }

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  // Column headers for export
  const columnHeaders = {
    dealer_transaction_id: "Dealer Transaction ID",
    dealer_transaction_details: "Dealer Transaction Details",
    amount: "Amount",
    action: "Action",
    credit_account: "Credit Account",
    debit_account: "Debit Account",
    creation_date: "Creation Date",
  };

  // Format date fields properly for export — e.g. "21/02/2025 10:25:52 AM"
  const formatDateForExport = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);

    // Format as DD/MM/YYYY HH:MM:SS AM/PM
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    // Ensure consistent spacing before AM/PM
    return formattedDate.replace(" am", " AM").replace(" pm", " PM");
  };

  // Corrected: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        // Only export if column is visible
        if (columnVisibilityModel[field] !== false) {
          const headerName = columnHeaders[field];

          // Only creation_date needs formatting
          if (field === "creation_date") {
            transformedRow[headerName] = formatDateForExport(row[field]);
          } else {
            // Default: use the value or empty string
            transformedRow[headerName] = row[field] ?? "";
          }
        }
      });

      return transformedRow;
    });
  };

  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Infrastructure Fee"); // Add sheet to workbook
    XLSX.writeFile(workbook, "Infrastructure Fee.xlsx"); // Trigger download of the Excel file
  };

  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    setTimeout(() => {
      setIsPressed(false);
    }, 200);
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <Button
        onClick={() => setShowFilterModal(true)}
        variant="outline-primary"
        style={{
          border: "none",
        }}
      >
        <img
          src={FilterSVG}
          alt="Filter Icon"
          style={{
            color: "white",
            width: "18px",
            marginRight: "8px",
            filter: "invert(0)", // keep black icon
          }}
        />
        Filter
      </Button>
      {/*<GridToolbarFilterButton />*/}
      <GridToolbarExport />
      <Button
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent",
          color: isPressed ? "black" : "#007bff",
          cursor: "pointer",
        }}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)",
          }}
        />
        Excel
      </Button>
    </GridToolbarContainer>
  );

  return (
    <div className="DealerInfrastructureFee">
      <Select
        value={dealers.find((option) => option.value === selectedOption)}
        onChange={handleSelectChange}
        options={dealers}
        placeholder="Select Dealer"
        isClearable
        styles={{
          control: (provided) => ({
            ...provided,
            margin: "10px",
          }),
        }}
      />
      <div
        className="d-flex justify-content-center my-3"
        style={{ color: "white" }}
      >
        <div className="mx-2">
          <label>Start Date:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{ color: "black", border: "1px solid white" }}
          />
        </div>
        <div className="mx-2">
          <label>End Date:</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{ color: "black", border: "1px solid white" }}
          />
        </div>
      </div>
      <div className="d-flex justify-content-around">
        <Card style={{ width: "18rem" }}>
          <Card.Body>
            <Card.Title>Commission</Card.Title>
            <Card.Text>Total Amount: {commissionTotal}</Card.Text>
          </Card.Body>
        </Card>
        <Card style={{ width: "18rem" }}>
          <Card.Body>
            <Card.Title>Recharge</Card.Title>
            <Card.Text>Total Amount: {rechargeTotal}</Card.Text>
          </Card.Body>
        </Card>
        <Card style={{ width: "18rem" }}>
          <Card.Body>
            <Card.Title>Percentage</Card.Title>
            <Card.Text>Total Amount: {percentageTotal}</Card.Text>
          </Card.Body>
        </Card>
      </div>
      <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
      <input
        type="text"
        placeholder="Search..."
        value={searchInput}
        onChange={handleSearchChange}
        className="search-client"
      />
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={(row) => row.dealer_transaction_id}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Toolbar: CustomToolbar,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            disableSelectionOnClick
          />
          <Modal
            show={showFilterModal}
            onHide={() => setShowFilterModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {columns
                .filter((col) => col.field !== "actions")
                .map((col) => (
                  <div key={col.field} className="filter">
                    <label>{col.headerName}</label>
                    <input
                      type="text"
                      placeholder={`Filter by ${col.headerName}`}
                      value={filters[col.field] || ""}
                      onChange={(e) =>
                        handleFilterChange(col.field, e.target.value)
                      }
                      className="filter-input"
                    />
                  </div>
                ))}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowFilterModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
      {loading && <p>Loading...</p>}
    </div>
  );
}

export default DealerInfrastructureFee;
